import { render, staticRenderFns } from "./memberListComponent.vue?vue&type=template&id=27f1549a&"
import script from "./memberListComponent.vue?vue&type=script&lang=ts&"
export * from "./memberListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports